/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

import ProtectedRoute from "layouts/auth/ProtectedRoute";

// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import VirtualReality from "layouts/virtual-reality";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
//import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// Nuevos
import Catalogos from "layouts/catalogos";
import Sellos from "layouts/catalogos/sellos";
import NuevoSello from "layouts/catalogos/sellos/nuevo-sello";
import EditarSello from "layouts/catalogos/sellos/editar-sello";
import Formatos from "layouts/catalogos/formatos";
import NuevoFormato from "layouts/catalogos/formatos/nuevo-formato";
import EditarFormato from "layouts/catalogos/formatos/editar-formato";
import Generos from "layouts/catalogos/generos";
import NuevoGenero from "layouts/catalogos/generos/nuevo-genero";
import EditarGenero from "layouts/catalogos/generos/editar-genero";
import Grabacion from "layouts/catalogos/grabacion";
import NuevaGrabacion from "layouts/catalogos/grabacion/nueva-grabacion";
import EditarGrabacion from "layouts/catalogos/grabacion/editar-grabacion";
import Reconocimientos from "layouts/catalogos/reconocimientos";
import NuevoReconocimiento from "layouts/catalogos/reconocimientos/nuevo-reconocimiento";
import EditarReconocimiento from "layouts/catalogos/reconocimientos/editar-reconocimiento";
import Parametros from "layouts/catalogos/parametros";
import NuevoParametro from "layouts/catalogos/parametros/nuevo-parametro";
import EditarParametro from "layouts/catalogos/parametros/editar-parametro";
import GruposCat from "layouts/catalogos/grupos";
import NuevoGrupo from "layouts/catalogos/grupos/nuevo-grupo";
import EditarGrupo from "layouts/catalogos/grupos/editar-grupo";

import Certificaciones from "layouts/certificaciones";
import NuevaCertificacion from "layouts/certificaciones/nueva-certificacion";
import EditarCertificacion from "layouts/certificaciones/editar-certificacion";
import Grupos from "layouts/autenticacion/grupos";
import Usuarios from "layouts/autenticacion/usuarios";
import EditarUsuario from "layouts/autenticacion/usuarios/editar-usuario";
import Reportes from "layouts/reportes";
import NuevoUsuario from "layouts/autenticacion/usuarios/nuevo-usuario";
import SignIn from "layouts/auth/SignIn"; // NUEVA ruta
import SignOut from "layouts/auth/SignOut";
import PasswordRecovery from "layouts/auth/PasswordRecovery";
import ForgotPassword from "layouts/auth/ForgotPassword";


// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Settings from "examples/Icons/Settings";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";

const routes = [
  {
    type: "route",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
    {
    type: "route",
    key: "sign-out",
    route: "/authentication/sign-out",
    component: <SignOut />,
  },
  {
    type: "route",
    key: "auth-recovery",
    route: "/auth/recovery/:key",
    // sin 'name' ni 'icon' para que no aparezca en el sidenav
    component: <PasswordRecovery />,
  },
  {
    type: "route",              // ✅ pública
    key: "auth-forgot",
    route: "/auth/forgot",
    component: <ForgotPassword />,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    auth: { module: "dashboard", action: "read" },
    component: (
      <ProtectedRoute module="dashboard" action="read">
        <Dashboard />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <CustomerSupport size="12px" />,
    component: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Autenticación",
    key: "autenticación",
    icon: <Document size="12px" />,
    collapse: [
    {
      type: "collapse",
      name: "Usuarios",
      key: "autenticacion-usuarios",
      icon: <Document size="12px" />,
      route: "/autenticacion/usuarios",
      auth: { module: "user", action: "read" },
    component: (
      <ProtectedRoute module="user" action="read">
        <Usuarios />
      </ProtectedRoute>
    ),
      noCollapse: true,
    },
  ],
  },
  {
    type: "route",                  
    name: "Nuevo usuario",          
    key:  "usuarios-nuevo",
    route: "/usuarios/nuevo",
    auth: { module: "user", action: "create" },       
    component: (
      <ProtectedRoute module="user" action="create">
        <NuevoUsuario />
      </ProtectedRoute>
    ),
  },
    {
    type: "route",
    name: "Editar usuario",
    key: "usuarios-editar",
    route: "/usuarios/:id/editar",
    auth: { module: "user", action: "update" },
    component: (
      <ProtectedRoute module="user" action="update">
        <EditarUsuario />
      </ProtectedRoute>
    ),
  },

  // ========== CATÁLOGOS ==========

  {
    type: "collapse",
    name: "Catalogos",
    key: "catalogos",
    icon: <Document size="12px" />,
    collapse: [
    {
      type: "collapse",
      name: "Sellos",
      key: "catalogos-sellos",
      icon: <Document size="12px" />,
      route: "/catalogos/sellos",
      auth: { module: "sellos", action: "read" },
    component: (
          <ProtectedRoute module="sellos" action="read">
            <Sellos />
          </ProtectedRoute>
        ),
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Formatos",
      key: "catalogos-formatos",
      icon: <Document size="12px" />,
      route: "/catalogos/formatos",
      auth: { module: "formatos", action: "read" },
      component: (
        <ProtectedRoute module="formatos" action="read">
          <Formatos />
        </ProtectedRoute>
      ),
      noCollapse: true,
      // meta: { module: "formatos", action: "read" }, // <- si filtras por permisos
    },
    {
      type: "collapse",
      name: "Géneros",
      key: "catalogos-generos",
      icon: <Document size="12px" />,
      route: "/catalogos/generos",
      auth: { module: "generos", action: "read" },
      component: (
          <ProtectedRoute module="generos" action="read">
            <Generos />
          </ProtectedRoute>
        ),
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Grupos",
      key: "catalogos-grupos",
      icon: <Document size="12px" />,
      route: "/catalogos/grupos",
      auth: { module: "grupos", action: "read" },
      component: (
          <ProtectedRoute module="grupos" action="read">
            <GruposCat />
          </ProtectedRoute>
        ),
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Grabación",
      key: "catalogos-grabacion",
      icon: <Document size="12px" />,
      route: "/catalogos/grabacion",
      auth: { module: "grabacion", action: "read" },
      component: (
        <ProtectedRoute module="grabacion" action="read">
          <Grabacion />
        </ProtectedRoute>
      ),
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Parámetros",
      key: "catalogos-parametros",
      icon: <Document size="12px" />,
      route: "/catalogos/parametros",
      auth: { module: "parametros", action: "read" },
      component: (
        <ProtectedRoute module="parametros" action="read">
          <Parametros />
        </ProtectedRoute>
      ),
      noCollapse: true,
      // si usas permisos en routes:
      meta: { perm: { module: "parametros", action: "read" } },
    },
    {
      type: "collapse",
      name: "Reconocimientos",
      key: "catalogos-reconocimientos",
      icon: <Document size="12px" />,
      route: "/catalogos/reconocimientos",
      auth: { module: "reconocimientos", action: "read" },
      component: (
          <ProtectedRoute module="reconocimientos" action="read">
            <Reconocimientos />
          </ProtectedRoute>
        ),
      noCollapse: true,
    },
  ],
  },

  // rutas de creación/edición de catálogos (aplica module y action)

  {
    type: "route",
    name: "Nuevo sello",
    key: "nuevo-sello",
    route: "/catalogos/sellos/nuevo",
    auth: { module: "sellos", action: "create" },
    component: (
      <ProtectedRoute module="sellos" action="create">
        <NuevoSello />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Editar sello",
    key: "editar-sello",
    route: "/catalogos/sellos/:id/editar",
    auth: { module: "sellos", action: "update" },
    component: (
      <ProtectedRoute module="sellos" action="update">
        <EditarSello />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Nuevo formato",
    key: "formatos-nuevo",
    route: "/catalogos/formatos/nuevo",
    component: (
      <ProtectedRoute>
        <NuevoFormato />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Editar formato",
    key: "formatos-editar",
    route: "/catalogos/formatos/:id/editar",
    component: (
      <ProtectedRoute>
        <EditarFormato />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Nuevo género",
    key: "nuevo-genero",
    route: "/catalogos/generos/nuevo",
    auth: { module: "generos", action: "create" },
    component: (
      <ProtectedRoute module="generos" action="create">
        <NuevoGenero />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Editar género",
    key: "editar-genero",
    route: "/catalogos/generos/:id/editar",
    auth: { module: "generos", action: "update" },
    component: (
      <ProtectedRoute module="generos" action="update">
        <EditarGenero />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Nueva grabación",
    key: "grabacion-nuevo",
    route: "/catalogos/grabacion/nuevo",
    component: (
      <ProtectedRoute>
        <NuevaGrabacion />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Editar grabación",
    key: "grabacion-editar",
    route: "/catalogos/grabacion/:id/editar",
    component: (
      <ProtectedRoute>
        <EditarGrabacion />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Nuevo grupo",
    key: "grupos-nuevo",
    route: "/catalogos/grupos/nuevo",
    auth: { module: "grupos", action: "create" },
    component: (
      <ProtectedRoute module="grupos" action="create">
        <NuevoGrupo />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Editar grupo",
    key: "grupos-editar",
    route: "/catalogos/grupos/:id/editar",
    auth: { module: "grupos", action: "update" },
    component: (
      <ProtectedRoute module="grupos" action="update">
        <EditarGrupo />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Nuevo parámetro",
    key: "parametros-nuevo",
    route: "/catalogos/parametros/nuevo",
    component: (
      <ProtectedRoute>
        <NuevoParametro />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Editar parámetro",
    key: "parametros-editar",
    route: "/catalogos/parametros/:id/editar",
    component: (
      <ProtectedRoute>
        <EditarParametro />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Nuevo reconocimiento",
    key: "reconocimientos-nuevo",
    route: "/catalogos/reconocimientos/nuevo",
    auth: { module: "reconocimientos", action: "create" },
    component: (
      <ProtectedRoute module="reconocimientos" action="create">
        <NuevoReconocimiento />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Editar reconocimiento",
    key: "reconocimientos-editar",
    route: "/catalogos/reconocimientos/:id/editar",
    auth: { module: "reconocimientos", action: "update" },
    component: (
      <ProtectedRoute module="reconocimientos" action="update">
        <EditarReconocimiento />
      </ProtectedRoute>
    ),
  },
  // Otros módulos
  {
    type: "collapse",
    name: "Certificaciones",
    key: "certificaciones",
    route: "/certificaciones",
    icon: <Office size="12px" />,
    auth: { module: "certificaciones", action: "read" },
    component: (
      <ProtectedRoute module="certificaciones" action="read">
        <Certificaciones />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
  {
    type: "route",
    name: "Nueva certificación",
    key: "certificaciones-nueva",
    route: "/certificaciones/nuevo",
    auth: { module: "certificaciones", action: "create" },
    component: (
      <ProtectedRoute module="certificaciones" action="create">
        <NuevaCertificacion />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    name: "Editar certificación",
    key: "certificaciones-editar",
    route: "/certificaciones/:id/editar",
    auth: { module: "certificaciones", action: "update" },
    component: (
      <ProtectedRoute module="certificaciones" action="update">
        <EditarCertificacion />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    name: "Reportes",
    key: "reportes",
    route: "/reportes",
    icon: <Office size="12px" />,
    auth: { module: "reportes", action: "read" },
    component: (
      <ProtectedRoute module="reportes" action="read">
        <Reportes />
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
];

export default routes;